// extracted by mini-css-extract-plugin
module.exports = {"priceIncludes":"InquiryPriceIncludes_priceIncludes__1AaAh","priceIncludesHeading":"InquiryPriceIncludes_priceIncludesHeading__3WLdE"};